import {GET_CONTENTS_FAIL, GET_CONTENTS_RESET, GET_CONTENTS_START, GET_CONTENTS_SUCCESS,} from "./constants";
import {GetContentsActions, GetContentsState} from "./types";

const initialState: GetContentsState = {
  // loading must be TRUE
  // when app starts isAppLoading logic gives FALSE at initial stage
  // this leads to unauthorized routes (lost of paycell redirect urls)
  loading: true,
  data: new Map<string, string>(),
  error: undefined,
}

const reducer = (
  state = initialState,
  action: GetContentsActions,
): GetContentsState => {
  switch (action.type) {
    case GET_CONTENTS_START:
      return {
        ...initialState,
        loading: true,
      }
    case GET_CONTENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case GET_CONTENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    case GET_CONTENTS_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
